import { render, staticRenderFns } from "./SpecializationsCard.vue?vue&type=template&id=a34de33c&scoped=true&"
import script from "./SpecializationsCard.vue?vue&type=script&lang=js&"
export * from "./SpecializationsCard.vue?vue&type=script&lang=js&"
import style0 from "./SpecializationsCard.vue?vue&type=style&index=0&id=a34de33c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34de33c",
  null
  
)

export default component.exports